import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {MobileInsuranceService} from '../../../services/mobile-insurance.service';
import {Response} from '../../../model/GeneralModels';

@Component({
  selector: 'app-mobile-token-page',
  templateUrl: './mobile-token-page.component.html',
  styleUrls: [
    '../../../assets/css/light.theme.css']
})
export class MobileTokenPageComponent implements OnInit {
  loginForm: FormGroup = this.fb.group({
    mobile: ['', Validators.required],
    requestToken: ['', Validators.required]
  });

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private services: MobileInsuranceService
  ) {
  }

  ngOnInit() {
  }

  getRequestID() {
    if (this.loginForm.valid) {
      this.router.navigate(['/mobile/guest/' + this.loginForm.controls.mobile.value + '/' + this.loginForm.controls.requestToken.value]);
    }
  }
}
